import React, { useEffect, useState } from 'react';

import closeIcon from '../../asset/img/common/close_icon.svg';
import { ModalStyled } from '../../asset/styled/component/ModalStyled';

const Modal = ({
  children,
  onClose,
  style = {},
  innerStyle,
  modalStyle,
  height,
  width,
  onClickBackground = () => {},
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 모달이 마운트된 후에 애니메이션을 시작하기 위해 상태를 업데이트
    setIsVisible(true);
    return () => {};
  }, []);

  return (
    <ModalStyled className={isVisible ? 'open' : ''} style={modalStyle} onClick={onClickBackground}>
      <div
        className="commonModalInner"
        style={{ height: height, width: width }}
        onClick={e => e.stopPropagation()}>
        {/* <div className="closeBox">
          <img src={closeIcon} className="closeImg" onClick={onClose} />
        </div> */}
        <div className="innerContents" style={{ ...innerStyle }} onClick={e => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </ModalStyled>
  );
};

export default Modal;
